import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0cccd722")

_pushScopeId("data-v-0cccd722")
const _hoisted_1 = { class: "tactics" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h5", null, [
  /*#__PURE__*/_createTextVNode("交流展示 "),
  /*#__PURE__*/_createVNode("span", null, "仅展示学习期间的组合收益情况")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "content"
}
const _hoisted_4 = {
  key: 1,
  class: "content"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_tabs = _resolveComponent("el-tabs")
  const _component_tactics_item = _resolveComponent("tactics-item")
  const _component_el_empty = _resolveComponent("el-empty")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_tabs, {
      class: "el_tabs",
      modelValue: _ctx.active,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.active = $event)),
      onTabClick: _ctx.tabChange
    }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
          return (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: tab.label,
            label: tab.label,
            name: tab.value
          }, null, 8, ["label", "name"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "onTabClick"]),
    (_ctx.tacticsItems.length)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tacticsItems, (item) => {
            return (_openBlock(), _createBlock(_component_tactics_item, {
              class: "tactics_item",
              item: item,
              key: item.strategy_id,
              onClick: ($event: any) => (_ctx.goDetail(item))
            }, null, 8, ["item", "onClick"]))
          }), 128))
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode(_component_el_empty, {
            class: "el_empty",
            description: "暂无组合"
          })
        ]))
  ]))
})